module.exports = __webpack_public_path__ + "static/media/calendar-arrow-right.860f2b27.svg";